<template>
  <div class="mx-3 mt-2 px-3 bg-white rounded-xl">
    <van-empty v-if="cards.length === 0" :description="$t('common.noData')" />
    <div v-for="(card, index) in cards" :key="index" class="py-4 border-b border-gray-100 last:border-b-0">
      <div class="mb-2 flex items-center justify-between text-gray-900">
        <div class="text-sm">{{ $t("binds.iccid") }}: {{ card.iccid }}</div>
        <van-icon name="delete" size="18" class="cursor-pointer" @click="handleDeleteBinding(card)" />
      </div>
      <div class="flex justify-between items-center text-sm text-gray-900">
        <div>
          <div class="font-medium mb-1">{{ isZh ? card.planName : card.planNameEn }}</div>
          <div class="mb-1">{{ isZh ? card.packageValue.name : card.packageValue.nameEn }} {{ card.day }} {{ (card.day > 1 ? $t("products.days") : $t("products.day"))}}</div>
          <div class="flex items-center">
            <span class="mr-2">
              {{ computedStatus(card.status) }}
            </span>
            <span class="" v-if="card.status == 0">({{$t("binds.deadline")}}: {{ card.validTime }})</span>
            <span class="" v-else-if="card.status == 3"></span>
            <span class="" v-else-if="card.status != 9 && card.status != 99">{{ card.startDate }} - {{ card.endDate }}</span>
          </div>
        </div>
        <div class="flex flex-col">
          <van-button
            type="primary"
            class="bg-gray-500 border-none w-18 h-6 rounded-md mb-2"
            :class="{ 'bg-orange-500':  card.status == 3 }"
            @click="handleQuery(card)">
            {{ $t("binds.query") }}
          </van-button>
          <van-button
            v-if="type === 'sim' && card.canRecharge === 1"
            type="primary"
            class="bg-gray-500 border-none w-18 h-6 rounded-md"
            :class="{ 'bg-orange-500': card.canRecharge === 1 && card.status == 9 }"
            @click="handleRecharge(card)">
            {{ $t("binds.recharge") }}
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Empty } from "vant"
import { mapGetters } from "vuex"

export default {
  name: "BindingCard",
  components: {
    [Empty.name]: Empty,
  },
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      required: true,
      validator: (value) => ["sim", "esim"].includes(value),
    },
  },
  computed: {
    ...mapGetters({
      isZh: "lang/isZh",
    }),
  },
  methods: {
    computedStatus(status) {
      // 0 未激活 1 已兑换 3 已激活 9 已结束 99 已失效
      let txt = ""
      switch (status) {
        case 0:
          txt = this.$t("binds.notActivated")
          break
        case 1:
          txt = this.$t("binds.exchanged")
          break
        case 3:
          txt = this.$t("binds.activated")
          break
        case 9:
          txt = this.$t("binds.finished")
          break
        case 99:
          txt = this.$t("binds.expired")
          break
        default:
          txt = status
          break
      }
      return txt
    },
    handleQuery(card) {
      if (card.status != 3) {
        return
      }
      this.$emit("query", card)
    },
    handleRecharge(card) {
      if (card.canRecharge === 0 || card.status != 9) {
        return
      }
      this.$emit("recharge", card)
    },
    handleDeleteBinding(card) {
      this.$emit("delete", card)
    },
  },
}
</script>

<style scoped>
/deep/ .target-div {
  width: 100%;
}
@media (min-width: 768px) {
  .parent /deep/ .target-div {
    margin: 0 1rem;
    width: calc(100% - 2rem);
  }
}
</style>
